var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiners(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 21,
    viewBox: "0 0 27 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2446 2.50781C6.93457 2.50781 3.42432 6.01807 3.42432 10.3281C3.42432 14.6382 6.93457 18.1484 11.2446 18.1484C15.5547 18.1484 19.0649 14.6382 19.0649 10.3281C19.0649 6.01807 15.5547 2.50781 11.2446 2.50781ZM9.46729 14.9492C7.64551 14.2383 6.3125 12.4609 6.3125 10.3281C6.3125 8.23975 7.64551 6.41797 9.46729 5.70703V14.9492ZM13.022 14.9492V5.70703C14.8882 6.41797 16.2212 8.23975 16.2212 10.3281C16.2212 12.4609 14.8882 14.2383 13.022 14.9492ZM24.0859 0.375H2.75781C1.55811 0.375 0.625 1.35254 0.625 2.50781V18.1484C0.625 19.3481 1.55811 20.2812 2.75781 20.2812H24.0859C25.2412 20.2812 26.2188 19.3481 26.2188 18.1484V2.50781C26.2188 1.35254 25.2412 0.375 24.0859 0.375ZM15.2437 18.8594H11.2446C6.53467 18.8594 2.62451 15.0825 2.62451 10.417C2.62451 5.35156 6.53467 1.79688 11.2446 1.79688H15.2437C19.9092 1.79688 24.1748 5.35156 24.1748 10.417C24.1748 15.0825 19.9092 18.8594 15.2437 18.8594Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiners);
export default __webpack_public_path__ + "static/media/Diners.52a3a9a7bd2dc810ad323822acfb9ac2.svg";
export { ForwardRef as ReactComponent };